import { render, staticRenderFns } from "./video_index.vue?vue&type=template&id=0f8bd162&scoped=true"
import script from "./video_index.vue?vue&type=script&lang=js"
export * from "./video_index.vue?vue&type=script&lang=js"
import style0 from "./video_index.vue?vue&type=style&index=0&id=0f8bd162&prod&scoped=true&lang=css"
import style1 from "./video_index.vue?vue&type=style&index=1&id=0f8bd162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8bd162",
  null
  
)

export default component.exports